import * as api from 'common/api'

// 成果状态
export async function status () {
  return [
    {id: '未审核', name: '未审核', color: 'grey'},
    {id: '审核通过', name: '审核通过', color: 'primary'},
    {id: '未通过', name: '未通过', color: 'warning'},
    {id: '已删除', name: '已删除', color: 'danger'},
  ]
}

// 教师查看成果列表
export let list = () => api.get('order/profile/list')

// 管理员查看审核过的成果列表
export let admin_list = () => api.get('order/manager/profile/check')

// 管理员获取待审核的成果列表
export let check_list = () => api.get('order/manager/profile/task')

// 查看成果
export let get = data => api.get('order/profile/edit', data)

// 教师删除成果
export let remove = data => api.post('order/profile/delete', data)

// 管理员审核成果
export let check = data => api.post('order/manager/profile/task', data)

// 创建、编辑成果
export let edit = data => api.postFile('order/profile/edit', data)

// 批量导入，check: true 表示直接通过了审核
export let import_data = data => api.post('order/profile/template/import', data)

// 根据模板上传 xls 文件批量录入成果
export let upload = data => api.postFile('order/profile/template/analysis', data)

export let export_data = params => api.get('order/profile/template/export', params)

// 成果是否可编辑
export let can_modify = item => !is_pass(item)

export let is_no_pass = item => item.status === '未通过'

export let is_pass = item => item.status === '审核通过'

// 成果类型，以及不同类型的 form 信息，以及模板 url
export let types = () => api.get('order/profile/types')



// WEBPACK FOOTER //
// ./src/api/achievement.js